export const durationTimeInMs = 300;
